import * as amplitude from "@amplitude/analytics-react-native"
import { theme } from "@common/theme/theme"
import { useNavigation, useRoute } from "@react-navigation/native"
import React, { useContext, useEffect } from "react"
import { Image, View } from "react-native"
import { ScrollView } from "react-native-gesture-handler"
import { ActivityIndicator } from "react-native-paper"
import { connect, useDispatch } from "react-redux"
import logo from "../../../assets/logo-blue.png"
import TextM from "../../common/components/text/TextM"
import { useApiStatus } from "../../common/hooks/useApiStatus"
import { useRequestsBatch } from "../../common/hooks/useRequestsBatch"
import { DimensionsContext, isWebMobile } from "../../common/utils/mobileUtils"
import {
    apiIdle,
    apiRequest,
    apiRequestWithPrerequest,
} from "../../data/redux/actions/api"
import { schoolCardReportService } from "../../data/services/schoolCardReportService"
import { ChampionImageM } from "../../student/champions/ChampionImageM"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"

function ScanLoadingScreen(props) {
    const dispatch = useDispatch()
    const navigation = useNavigation()
    const dimensions = useContext(DimensionsContext)
    const route = useRoute()
    const studentClass = route?.params?.student_class || null

    const [globalProgress, submitted, startRequests] = useRequestsBatch(
        [],
        [props.reportFile],
        "SCHOOL-CARD-REPORT",
        {
            service: schoolCardReportService.processFile,
            data: {},
            tmpFilesKey: "school_card_report",
            tmpFilesFormatter: (attachmentTmp) => {
                return attachmentTmp
            },
            additionalData: [
                {
                    student_class: studentClass,
                },
            ],
            params: {},
            onSuccessBeforeNext: () => {},
        },
        [],
        true,
        true
    )

    useApiStatus(
        schoolCardReportService.processFile,
        null,
        false,
        () => {
            dispatch(props.apiIdle(schoolCardReportService.processFile))
            setTimeout(() => {
                navigation.navigate({
                    name: "school-card-report/diagnostic",
                    params: { getMail: true },
                })
            }, 1000)
        },
        () => {
            dispatch(props.apiIdle(schoolCardReportService.processFile))
            navigation.navigate({
                name: "school-card-report",
                params: { error: true },
            })
        }
    )

    useEffect(() => {
        startRequests()
    }, [])

    useEffect(() => {
        amplitude.track("school_card_report.scan_loading_screen")
    }, [])

    const width =
        dimensions.width > 800 ? dimensions.width / 2.2 : dimensions.width - 60

    return (
        <ScrollView
            showsVerticalScrollIndicator={false}
            showsHorizontalScrollIndicator={false}
            horizontal={false}
            style={{ flex: 1, width: "100%" }}
            contentContainerStyle={{
                flexGrow: 1,
                alignItems: "center",
                ...(isWebMobile() && { minHeight: "100dvh" }),
            }}
        >
            <View
                style={{
                    width: "100%",
                    paddingTop: 20,
                    marginBottom: 20,
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Image
                    source={logo}
                    style={{
                        width,
                        height: 120,
                        resizeMode: "contain",
                        borderRadius: 8,
                    }}
                />

                <TextM
                    fontSize={32}
                    fontWeight="ExtraBold"
                    color={theme.colors.primary}
                    style={{
                        textAlign: "center",
                        marginHorizontal: 16,
                        marginTop: 20,
                    }}
                    wrap
                >
                    Scannez un bulletin scolaire !
                </TextM>
                <TextM
                    fontSize={14}
                    fontWeight="Medium"
                    color={theme.colors.grey}
                    style={{
                        textAlign: "center",
                        marginHorizontal: 16,
                    }}
                    wrap
                >
                    Recevez votre bilan personnalisé en quelques instants
                </TextM>

                <View
                    style={{
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: 24,
                    }}
                >
                    <ChampionImageM
                        name="zoe"
                        variant="happy"
                        width={(width * 2) / 5}
                    />

                    <TextM
                        fontSize={16}
                        fontWeight="regular"
                        color={theme.colors.primary}
                        style={{
                            marginTop: 20,
                            textAlign: "center",
                        }}
                        wrap
                    >
                        Un instant, on analyse votre bulletin avec précision...
                        ⏳
                    </TextM>

                    <ActivityIndicator
                        size="large"
                        color={theme.colors.primary}
                        style={{
                            marginTop: 20,
                        }}
                    />
                </View>
            </View>

            <View style={{ flex: 1 }} />

            <View
                style={{
                    width: "100%",
                    paddingHorizontal: 20,
                    marginBottom: 20,
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "row"
                }}
            >
                <FontAwesome5 name="lock"
                              solid
                              size={10}
                              style={{
                                  marginRight: 4,
                                  marginBottom: 2
                              }}
                              color={theme.colors.link}/>
                <TextM fontSize={10} fontWeight="Regular" color={theme.colors.link} wrap>
                    Vos données sont sécurisées
                </TextM>
            </View>
        </ScrollView>
    )
}

const mapStateToProps = (state) => ({
    reportFile: state.data.formData?.reportFile,
})

const mapDispatchToProps = {
    apiRequest,
    apiRequestWithPrerequest,
    apiIdle,
}

export default connect(mapStateToProps, mapDispatchToProps)(ScanLoadingScreen)
